module.exports = __webpack_public_path__ + "img/744.8c47b0c3.jpg";